// src/application/RankingService.js
import { RankingRepository } from '../infrastructure/RankingRepository';

export class RankingService {
    constructor() {
        this.repository = new RankingRepository();
    }

    async getLastSixMonthsEmissions(region) {
        try {
            const emissionsData = await this.repository.fetchLastSixMonthsEmissions(region);

            if (!emissionsData || !Array.isArray(emissionsData)) {
                throw new Error('無效的碳排放數據');
            }

            return emissionsData;
        } catch (error) {
            console.error('Error in RankingService getLastSixMonthsEmissions:', error);
            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取碳排放數據時發生未知錯誤');
            }
        }
    }

    async getMonthlyStats(region) {
        try {
            const monthlyStats = await this.repository.fetchMonthlyStats(region);

            if (!monthlyStats || typeof monthlyStats !== 'object') {
                throw new Error('無效的月度統計數據');
            }

            return {
                month: monthlyStats.month || '',
                totalMileage: monthlyStats.totalMileage || 0,
                totalEmission: monthlyStats.totalEmission || 0,
                emission_per_km: monthlyStats.emission_per_km || 0,
                emission_reduction_percentage: monthlyStats.emission_reduction_percentage || 0
            };
        } catch (error) {
            console.error('Error in RankingService getMonthlyStats:', error);
            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取月度統計數據時發生未知錯誤');
            }
        }
    }

    async getNewRankings(region) {
        try {
            const rankingsData = await this.repository.fetchNewRankings(region);

            if (!rankingsData || typeof rankingsData !== 'object') {
                throw new Error('無效的排名數據');
            }

            return {
                mileageRanking: rankingsData.mileageRanking || [],
                emissionsRanking: rankingsData.emissionsRanking || [],
                reductionPercentage: rankingsData.reductionPercentage || []
            };
        } catch (error) {
            console.error('Error in RankingService getNewRankings:', error);
            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取新排名數據時發生未知錯誤');
            }
        }
    }

    async getRankings(region) {
        try {
            const rankingsData = await this.repository.fetchRankings(region);

            if (!rankingsData || typeof rankingsData !== 'object') {
                throw new Error('無效的排名數據');
            }

            return {
                mileageRanking: rankingsData.mileageRanking || [],
                emissionsRanking: rankingsData.emissionsRanking || [],
                reductionPercentage: rankingsData.reductionPercentage || []
            };
        } catch (error) {
            console.error('Error in RankingService:', error);
            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取排名數據時發生未知錯誤');
            }
        }
    }

    async getStats() {
        try {
            const statsData = await this.repository.fetchStats();

            if (!statsData || typeof statsData !== 'object') {
                throw new Error('無效的碳排放統計數據');
            }

            return {
                totalTrips: statsData.totalTrips || 0,
                totalDistance: statsData.totalDistance || 0,
                totalEmissions: statsData.totalEmissions || 0,
                avgEmissionsPerPassenger: statsData.avgEmissionsPerPassenger || 0,
                estimatedCarbonFee: statsData.estimatedCarbonFee || 0,
                emissionsPerTrip: statsData.emissionsPerTrip || 0,
                reductionPercentage: statsData.reductionPercentage || 0
            };
        } catch (error) {
            console.error('Error in RankingService getStats:', error);
            if (error instanceof Error) {
                throw error;
            } else {
                throw new Error('獲取碳排放統計數據時發生未知錯誤');
            }
        }
    }
}